// Organik Kal cart: milestones, timers, social proof and campaign UI.
(function initCartMarketing(global) {
    'use strict';

    const namespace = global.OrganikKalCart = global.OrganikKalCart || {};

    namespace.createCartMarketing = function createCartMarketing({
        settings,
        locales,
        api,
        onCartExpired,
        onExitCoupon,
        hasCartItems
    }) {
        const { formatCurrency, setTemplateText } = namespace.utils;
        const reached = { 1: false, 2: false, 3: false };
        let cartTimer = null;
        let secondsRemaining = 0;
        let socialTimer = null;
        let exitTimer = null;
        let exitSeconds = 300;
        let exitTriggered = false;
        const exitOfferClaimedKey = 'organikkal_first_order_offer_claimed';
        const exitEmailKeyPrefix = 'organikkal_first_order_email:';

        const dom = {
            milestoneContainer: document.getElementById('lumicart-shipping-container'),
            milestoneText: document.getElementById('lumicart-shipping-text'),
            progressFill: document.getElementById('lumicart-progress-bar-fill'),
            milestoneDots: document.getElementById('lumicart-milestones-container'),
            rewards: document.getElementById('lumicart-rewards-list-container'),
            fomo: document.getElementById('lumicart-fomo-banner'),
            fomoText: document.getElementById('lumicart-fomo-text'),
            social: document.getElementById('lumicart-socialproof-banner'),
            socialText: document.getElementById('lumicart-socialproof-text'),
            exitBackdrop: document.getElementById('lumicart-exit-popup-backdrop'),
            exitForm: document.getElementById('LumiCartExitForm'),
            exitClose: document.getElementById('lumicart-exit-popup-close'),
            exitSubmit: document.getElementById('lumicart-exit-submit-btn'),
            exitEmail: document.getElementById('lumicart-exit-email-input'),
            exitError: document.getElementById('lumicart-exit-popup-error-msg'),
            exitTimer: document.getElementById('lumicart-exit-timer'),
            exitSuccess: document.querySelector('[data-exit-form-success]'),
            exitFormError: document.querySelector('[data-exit-form-error]')
        };

        function init() {
            initSocialProof();
            initExitIntent();
            restoreSubmittedExitCoupon();
        }

        function sync(cart, subtotal) {
            updateMilestones(subtotal);
            const hasItems = cart.item_count > 0;
            toggle(dom.fomo, hasItems && settings.enableTimer);
            toggle(dom.social, hasItems && settings.enableSocialproof);

            if (hasItems && settings.enableTimer && !cartTimer) startCartTimer();
            if (!hasItems) stopCartTimer();
        }

        function updateMilestones(subtotal) {
            if (!settings.enableMilestones || !dom.milestoneContainer) {
                toggle(dom.milestoneContainer, false);
                return;
            }

            const discountPercent = Math.min(50, Math.max(1, Number(settings.discountPercent) || 10));
            const giftTitle = settings.giftProductTitle || locales.free_gift_label || 'Hediye';
            const milestones = [
                createMilestone(1, settings.shippingGoal, locales.milestone_shipping, locales.shipping_progress_1),
                createMilestone(2, settings.giftGoal, settings.giftProductTitle ? `+${settings.giftProductTitle}` : locales.milestone_gift, locales.shipping_progress_2),
                createMilestone(3, settings.discountGoal, replaceDiscount(locales.milestone_discount, discountPercent), locales.shipping_progress_3)
            ].filter(Boolean).sort((a, b) => a.value - b.value);

            if (milestones.length === 0) {
                toggle(dom.milestoneContainer, false);
                return;
            }

            toggle(dom.milestoneContainer, true, 'block');
            const maxGoal = milestones[milestones.length - 1].value;
            renderMilestoneDots(milestones, subtotal, maxGoal);
            renderRewardCards(milestones, subtotal);
            dom.progressFill.style.width = `${Math.min((subtotal / maxGoal) * 100, 100)}%`;

            milestones.forEach(milestone => {
                const unlocked = subtotal >= milestone.value;
                if (milestone.id === 1 && unlocked && !reached[milestone.id] && settings.enableConfetti && !hasShownShippingConfetti()) {
                    triggerConfetti();
                    rememberShippingConfetti();
                }
                reached[milestone.id] = unlocked;
            });

            const next = milestones.find(milestone => subtotal < milestone.value);
            if (!next) {
                dom.milestoneText.textContent = locales.shipping_progress_all;
                return;
            }

            setTemplateText(dom.milestoneText, next.progressText, {
                remaining: formatCurrency(next.value - subtotal),
                gift: giftTitle,
                discount: discountPercent
            });
        }

        function createMilestone(id, rawValue, label, progressText) {
            const value = Number(rawValue);
            return Number.isFinite(value) && value > 0
                ? { id, value, label: String(label || ''), progressText: String(progressText || '') }
                : null;
        }

        function replaceDiscount(label, percent) {
            return String(label || '-%{{ discount }} İndirim').replace('{{ discount }}', percent);
        }

        function renderMilestoneDots(milestones, subtotal, maxGoal) {
            dom.milestoneDots.replaceChildren(...milestones.map(milestone => {
                const element = document.createElement('div');
                element.className = `lumicart-milestone ${subtotal >= milestone.value ? 'reached' : ''}`;
                element.style.left = `${(milestone.value / maxGoal) * 100}%`;
                const dot = document.createElement('div');
                dot.className = 'lumicart-dot';
                element.append(dot);
                return element;
            }));
        }

        function renderRewardCards(milestones, subtotal) {
            dom.rewards.replaceChildren(...milestones.map(milestone => {
                const unlocked = subtotal >= milestone.value;
                const card = document.createElement('div');
                card.className = `lumicart-reward-card ${unlocked ? 'reached' : 'locked'}`;

                const header = document.createElement('div');
                header.className = 'reward-card-header';
                const icon = document.createElement('div');
                icon.className = 'reward-card-icon-wrapper';
                icon.append(createRewardIcon(milestone.id));
                const badge = document.createElement('span');
                badge.className = `reward-status-badge ${unlocked ? 'reached-badge' : 'locked-badge'}`;
                badge.textContent = unlocked ? '✓' : formatCurrency(milestone.value);
                header.append(icon, badge);

                const body = document.createElement('div');
                body.className = 'reward-card-body';
                const title = document.createElement('span');
                title.className = 'reward-card-title';
                title.textContent = milestone.label;
                body.append(title);
                card.append(header, body);
                return card;
            }));
        }

        function createRewardIcon(id) {
            const wrapper = document.createElement('span');
            wrapper.setAttribute('aria-hidden', 'true');
            wrapper.className = 'reward-card-icon';
            wrapper.textContent = id === 1 ? '🚚' : id === 2 ? '🎁' : '%';
            return wrapper;
        }

        function startCartTimer() {
            secondsRemaining = Math.max(1, Number(settings.timerDuration) || 10) * 60;
            updateCartTimerText();
            cartTimer = global.setInterval(async () => {
                secondsRemaining -= 1;
                updateCartTimerText();
                if (secondsRemaining > 0) return;

                stopCartTimer();
                try {
                    await api.clearCart();
                    onCartExpired();
                    showAlert(
                        locales.timer_expired_title || 'Süre Doldu!',
                        locales.timer_expired_message || 'Sepet süreniz sona erdiği için sepetiniz boşaltıldı.'
                    );
                } catch (error) {
                    console.error('Cart expiration failed:', error);
                }
            }, 1000);
        }

        function stopCartTimer() {
            global.clearInterval(cartTimer);
            cartTimer = null;
            secondsRemaining = 0;
        }

        function updateCartTimerText() {
            const minutes = Math.floor(secondsRemaining / 60);
            const seconds = secondsRemaining % 60;
            const timer = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            setTemplateText(dom.fomoText, locales.fomo_timer, { timer });
        }

        function initSocialProof() {
            if (!settings.enableSocialproof) return;
            updateSocialProof();
            socialTimer = global.setInterval(() => {
                if (hasCartItems()) updateSocialProof();
            }, 5000);
        }

        function updateSocialProof() {
            setTemplateText(dom.socialText, locales.socialproof, {
                count: Math.floor(Math.random() * 8) + 5
            });
        }

        function initExitIntent() {
            if (!settings.enableExitintent || !dom.exitBackdrop || hasClaimedExitOffer()) {
                dom.exitBackdrop?.remove();
                return;
            }
            document.addEventListener('mouseleave', event => {
                if (!exitTriggered && hasCartItems() && event.clientY < 20) showExitPopup();
            });
            dom.exitClose?.addEventListener('click', closeExitPopup);
            dom.exitBackdrop.addEventListener('click', event => {
                if (event.target === dom.exitBackdrop) closeExitPopup();
            });
            dom.exitEmail?.addEventListener('input', () => toggle(dom.exitError, false));
            dom.exitForm?.addEventListener('submit', submitExitCoupon);
        }

        function showExitPopup() {
            if (hasClaimedExitOffer()) return;
            exitTriggered = true;
            dom.exitBackdrop.classList.add('active');
            exitSeconds = 300;
            updateExitTimer();
            global.clearInterval(exitTimer);
            exitTimer = global.setInterval(() => {
                exitSeconds -= 1;
                updateExitTimer();
                if (exitSeconds <= 0) closeExitPopup();
            }, 1000);
        }

        function closeExitPopup() {
            dom.exitBackdrop?.classList.remove('active');
            global.clearInterval(exitTimer);
            exitTimer = null;
        }

        function updateExitTimer() {
            const timer = `${String(Math.floor(exitSeconds / 60)).padStart(2, '0')}:${String(exitSeconds % 60).padStart(2, '0')}`;
            if (dom.exitTimer) {
                dom.exitTimer.textContent = String(locales.exit_timer_message || '').replace('{{ timer }}', timer);
            }
        }

        function submitExitCoupon(event) {
            const email = String(dom.exitEmail?.value || '').trim().toLowerCase().slice(0, 254);
            const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
            if (!valid) {
                event.preventDefault();
                if (dom.exitError) {
                    dom.exitError.textContent = locales.exit_email_error || 'Lütfen geçerli bir e-posta adresi girin.';
                    dom.exitError.className = 'exit-popup-message error';
                    toggle(dom.exitError, true);
                }
                return;
            }

            if (hasSubmittedEmail(email)) {
                event.preventDefault();
                if (dom.exitError) {
                    dom.exitError.textContent = 'Bu e-posta adresi için ilk sipariş teklifi daha önce alınmış.';
                    dom.exitError.className = 'exit-popup-message error';
                    toggle(dom.exitError, true);
                }
                return;
            }

            const code = String(settings.exitCouponCode || 'SEPET5').trim().toUpperCase();
            const percent = Math.min(50, Math.max(1, Number(settings.exitDiscountPercent) || 5));
            if (dom.exitSubmit) {
                dom.exitSubmit.disabled = true;
                dom.exitSubmit.textContent = 'Kaydediliyor…';
            }
            try {
                global.sessionStorage.setItem('organikkal_exit_coupon_pending', JSON.stringify({ code, percent, email }));
            } catch (_error) {
                /* The Shopify customer form still submits when storage is unavailable. */
            }
        }

        function hasClaimedExitOffer() {
            try {
                return global.localStorage.getItem(exitOfferClaimedKey) === 'true';
            } catch (_error) {
                return false;
            }
        }

        function hasSubmittedEmail(email) {
            try {
                return global.localStorage.getItem(`${exitEmailKeyPrefix}${email}`) === 'true';
            } catch (_error) {
                return false;
            }
        }

        function restoreSubmittedExitCoupon() {
            let pending = null;
            try {
                pending = JSON.parse(global.sessionStorage.getItem('organikkal_exit_coupon_pending') || 'null');
                global.sessionStorage.removeItem('organikkal_exit_coupon_pending');
            } catch (_error) { pending = null; }
            if (dom.exitFormError) {
                dom.exitError.textContent = dom.exitFormError.textContent || 'E-posta kaydedilemedi. Lütfen tekrar deneyin.';
                dom.exitError.className = 'exit-popup-message error';
                toggle(dom.exitError, true);
            }
            if (!pending?.code) return;
            if (!dom.exitSuccess) return;
            try {
                global.localStorage.setItem('lumicart_coupon', String(pending.code));
                global.localStorage.setItem(exitOfferClaimedKey, 'true');
                if (pending.email) global.localStorage.setItem(`${exitEmailKeyPrefix}${pending.email}`, 'true');
            } catch (_error) {
                /* The offer still applies even when persistent storage is unavailable. */
            }
            onExitCoupon(String(pending.code));
            showAlert('İlk sipariş indiriminiz hazır', `%${Number(pending.percent) || 5} ilk sipariş indirim kodunuz sepetinize uygulandı: ${pending.code}`);
        }

        function hasShownShippingConfetti() {
            try { return global.sessionStorage.getItem('organikkal_shipping_confetti_shown') === 'true'; }
            catch (_error) { return false; }
        }

        function rememberShippingConfetti() {
            try { global.sessionStorage.setItem('organikkal_shipping_confetti_shown', 'true'); }
            catch (_error) { /* Session storage can be unavailable in privacy modes. */ }
        }

        function showAlert(title, message) {
            const backdrop = document.getElementById('lumicart-alert-backdrop');
            const titleElement = document.getElementById('lumicart-alert-title');
            const messageElement = document.getElementById('lumicart-alert-message');
            const button = document.getElementById('lumicart-alert-btn');
            if (!backdrop || !titleElement || !messageElement || !button) return;

            titleElement.textContent = String(title);
            messageElement.textContent = String(message);
            button.textContent = locales.shipping_free === 'Ücretsiz' ? 'Tamam' : 'Okay';
            backdrop.classList.add('active');
            button.addEventListener('click', () => backdrop.classList.remove('active'), { once: true });
        }

        function toggle(element, visible, display = 'flex') {
            if (element) element.style.display = visible ? display : 'none';
        }

        function triggerConfetti() {
            const canvas = document.getElementById('lumicart-confetti-canvas');
            const context = canvas?.getContext('2d');
            if (!canvas || !context) return;

            canvas.width = global.innerWidth;
            canvas.height = global.innerHeight;
            const colors = ['#c86f42', '#1f523f', '#6fac68', '#e5b858'];
            const particles = Array.from({ length: 90 }, () => ({
                x: Math.random() * canvas.width,
                y: Math.random() * -canvas.height,
                size: Math.random() * 5 + 3,
                color: colors[Math.floor(Math.random() * colors.length)],
                drift: Math.random() * 0.12 - 0.06
            }));

            function draw() {
                context.clearRect(0, 0, canvas.width, canvas.height);
                let active = false;
                particles.forEach(particle => {
                    particle.y += 3 + particle.size / 3;
                    particle.x += particle.drift;
                    if (particle.y < canvas.height) active = true;
                    context.fillStyle = particle.color;
                    context.fillRect(particle.x, particle.y, particle.size, particle.size * 0.45);
                });
                if (active) global.requestAnimationFrame(draw);
                else context.clearRect(0, 0, canvas.width, canvas.height);
            }
            draw();
        }

        return Object.freeze({ init, showAlert, sync });
    };
})(window);
